import React, { useEffect, useState, useContext } from 'react';
import { useSelector } from 'react-redux';
import { useAspSelector } from '../../../../test/jest-redux-hooks';
import {
  cityListApi,
  contactOriginApi,
  countryListApi,
  crmFileView,
  crmIgnore,
  crmListShow,
  crmListUpdate,
  crmViewCount,
  stateListApi,
  crmTagRemove,
  crmTagSingleAssign,
  AudienceSetMembersList,
  AudienceSetSingle,
  AudienceSetList,
} from '../../api/Api';
import { Base64 } from 'js-base64';
import Header from './contact/Header';
import MainContactList from './contact/MainContactList';
import { MainFilter } from './MainFilter';
import { Search } from './Search';
import useToggle from '../../../../hooks/useToggle';
import { Sidebar } from '../sidebar';
import { useQuery } from '@tanstack/react-query';
import NotificationContext from '../../../../providers/NotificationProvider';
import {
  showSuccessToast,
  showErrorToast,
} from '../../../../components/commonComponents/gxAntdToast/toastUtils';

let count = 0;
let count1 = 0;
let viewCount = 0;

const index = () => {
  const { crmColumn } = useSelector((store) => store.crm);
  const [crmLists, setCrmLists] = useState([]);
  const { currentBrand } = useAspSelector((state) => state.app);
  const [isLoading, setIsLoading] = useState(false);
  const [no, setNo] = useState(false);
  const [isFilter, setIsFilter] = useState('');
  const [filters, setFilters] = useState({});
  const [origins, setOrigins] = useState([]);
  const [newContactActive, setNewContactActive] = useState(false);
  const [importFrom, setImportFrom] = useState('csv');
  const [continueLoader, setContinueLoader] = useToggle(false);

  const [viewLists, setViewLists] = useState([]);
  const [viewListsShow, setViewListsShow] = useState(false);
  const [ignoreCall, setIgnoreCall] = useState(false);
  const [viewListsCount, setViewListsCount] = useState(null);
  const [audienceSets, setAudienceSets] = useState([]);

  // LOCATIONS
  const [countryListss, setCountryListss] = useState([]);
  const [countryTrue, setCountryTrue] = useState({});

  const [stateList, setStateList] = useState([]);
  const [provinceTrue, setProvinceTrue] = useState({});
  const [cityList, setCityList] = useState([]);
  const [cityTrue, setCityTrue] = useState({});

  const [emailTrue, setEmailTrue] = useState({});

  const [countCheck, setCountCheck] = useState(false);

  // Pagination state
  const [page, setPage] = useState(1);

  const [activeFilter, setActiveFilter] = useState('');

  // SELECTED CONTACTS
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [totalSelectedCount, setTotalSelectedCount] = useState(0);
  const [deselectedIds, setDeselectedIds] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);

  // NOTIFICATION(Toast)
  const notification = useContext(NotificationContext);

  const handleEmail = (id) => {
    setCountCheck(false);

    setEmailTrue((prev) => ({
      ...prev,
      [id]: true,
    }));
  };

  const handleCountry = (id) => {
    setCountCheck(false);

    countryListApi().then((res) => {
      if (res && res.data?.data?.length > 0) {
        const updatedData = res.data.data.map((item) => ({
          ...item,
          label: item.name,
        }));

        setCountryListss(updatedData);
        setCountryTrue((prev) => ({
          ...prev,
          [id]: true,
        }));
      }
    });
  };

  const handleCountryChange = (id, value) => {
    setCountCheck(false);

    setViewLists((prev) =>
      prev.map((item) =>
        item.id === id
          ? {
              ...item,
              contact_person_info: {
                ...item.contact_person_info,
                country: value.label,
              },
            }
          : item,
      ),
    );
  };

  const handleDelete = (id) => {
    setCountCheck(false);

    setCountryTrue((prev) => ({
      ...prev,
      [id]: false,
    }));
    setProvinceTrue((prev) => ({
      ...prev,
      [id]: false,
    }));
    setCityTrue((prev) => ({
      ...prev,
      [id]: false,
    }));
    setEmailTrue((prev) => ({
      ...prev,
      [id]: false,
    }));
  };

  const handleProvince = (id) => {
    setCountCheck(false);

    stateListApi(2).then((res) => {
      if (res && res?.data?.data?.length > 0) {
        const updateState = res?.data?.data?.map((item) => {
          return { ...item, label: item?.name };
        });
        setStateList(updateState);
        setProvinceTrue((prev) => ({
          ...prev,
          [id]: true,
        }));
      }
    });
  };

  const handleProvinceChange = (id, value) => {
    setCountCheck(false);

    setViewLists((prev) =>
      prev.map((item) =>
        item.id === id
          ? {
              ...item,
              contact_person_info: {
                ...item.contact_person_info,
                province: value.label,
              },
            }
          : item,
      ),
    );
  };

  const handleEmailChange = (id, value) => {
    setCountCheck(false);
    setViewLists((prev) =>
      prev.map((item) =>
        item.id === id
          ? {
              ...item,
              contact_person_info: {
                ...item.contact_person_info,
                'email-id': value,
              },
            }
          : item,
      ),
    );
  };

  const handleCity = (id, l) => {
    setCountCheck(false);

    cityListApi(l?.contact_person_info?.['province-id']).then((res) => {
      if (res && res?.data?.data?.length > 0) {
        const updateCity = res?.data?.data?.map((item) => {
          return { ...item, label: item?.name };
        });
        setCityList(updateCity);
        setCityTrue((prev) => ({
          ...prev,
          [id]: true,
        }));
      }
    });
  };

  const handleCityChange = (id, value) => {
    setCountCheck(false);

    setViewLists((prev) =>
      prev.map((item) =>
        item.id === id
          ? {
              ...item,
              contact_person_info: {
                ...item.contact_person_info,
                city: value.label,
              },
            }
          : item,
      ),
    );
  };

  useEffect(() => {
    crmViewCount(currentBrand?.brand_id).then((res) => {
      if (res?.status === 200) {
        setViewListsCount(res?.data?.contacts_count);

        if (res?.data?.contacts_count === 0) {
          setViewListsShow(false);
        }
      }
    });
  }, []);

  const handleIgnore = () => {
    crmIgnore(currentBrand?.brand_id).then((res) => {
      if (res?.status === 200) {
        setIgnoreCall(true);
        setViewListsShow(false);
      }
    });
  };

  const getViewList = (brandId, payload) => {
    if (!brandId) return;

    const queryParams = {
      page: payload?.page,
      limit: payload?.limit,
      name: payload?.name,
    };

    setIsLoading(true);
    setNo(true);

    crmFileView(brandId, queryParams)
      .then((res) => {
        setNo(true);

        const newContacts = res?.data?.contacts || [];
        viewCount = res?.data?.contacts_count;

        setViewLists((prevLists) => {
          if (payload?.page === 1) {
            return newContacts.filter((item) => item.status !== -1);
          } else {
            const updatedList = prevLists.map((item) => {
              const updatedItem = newContacts.find(
                (newItem) => newItem.id === item.id,
              );
              return updatedItem ? updatedItem : item;
            });

            const newUniqueItems = newContacts.filter(
              (newItem) =>
                !prevLists.some((item) => item.id === newItem.id) &&
                newItem.status !== -1,
            );

            return [...updatedList, ...newUniqueItems].filter(
              (item) => item.status !== -1,
            );
          }
        });

        if (res?.data?.contacts_count === 0) {
          setViewListsShow(false);
          window.location.reload();
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleUpdate = (l, id) => {
    const payLoad = {
      brand_id: currentBrand?.brand_id,
      crm_failed_contact_id: l?.id,
      details: {
        country: l?.contact_person_info?.country,
        province: l?.contact_person_info?.province,
        city: l?.contact_person_info?.city,
        'email-id': l?.contact_person_info?.['email-id'],
        'last-name': l?.last_name,
        'first-name': l?.first_name,
        'sms-otp-out': false,
        'country-code': l?.contact_person_info?.['country-code'],
        'email-otp-out': false,
        'mobile-number': l?.contact_person_info?.['mobile-number'],
        'whatsapp-otp-out': l?.contact_person_info?.['whatsapp-otp-out'],
        profile_attributes: {
          ...l?.profile_attributes,
          email_address: l?.contact_person_info?.['email-id'],
          country_code: l?.contact_person_info?.['country-code'],
          mobile_number: l?.contact_person_info?.['mobile-number'],
          first_name: l?.first_name,
          last_name: l?.last_name,
        },
      },
    };
    crmListUpdate(payLoad).then((res) => {
      if (res?.status === 200) {
        setCountCheck(true);
        setCountryTrue((prev) => ({
          ...prev,
          [id]: false,
        }));
        setProvinceTrue((prev) => ({
          ...prev,
          [id]: false,
        }));
        setEmailTrue((prev) => ({
          ...prev,
          [id]: false,
        }));
        setCityTrue((prev) => ({
          ...prev,
          [id]: false,
        }));
        setViewLists((prevList) =>
          prevList.map((item) =>
            item.id === l.id
              ? { ...item, ...l, ...(res?.data?.crm_failed_contact || {}) }
              : item,
          ),
        );
      }
    });
  };

  const handleView = () => {
    setViewListsShow(true);
    getViewList(currentBrand?.brand_id);
  };

  const handleAllContacts = () => {
    setViewListsShow(false);
    getCrmList(currentBrand?.brand_id, {
      page: page,
      limit: 10,
      search: isFilter,
      filters: filters,
    });
  };

  // Handle search and filter changes
  useEffect(() => {
    // Reset to first page when search or filter changes
    setPage(1);
    setCrmLists([]);
    setIsLoading(true);

    if (activeFilter?.type === 'audience_set') {
      // For audience sets, use the audience set API
      getAudienceSetMembers(
        currentBrand?.brand_id,
        activeFilter,
        1, // Always start from first page on search
        10,
        isFilter || '', // Ensure search is a string, even if empty
      );
    } else if (viewListsShow) {
      // For regular view lists
      setTimeout(() => {
        setViewListsShow(true);
        getViewList(currentBrand?.brand_id, {
          page: 1, // Always start from first page on search
          limit: 15,
          name: isFilter || '',
        });
      }, 500);
    } else {
      const params = {
        page: page,
        limit: 10,
        search: isFilter,
        filters: filters,
        contact_origin: activeFilter.name,
        tag_id: activeFilter.tag ? activeFilter.id : undefined,
      };

      if (activeFilter?.user_name || activeFilter?.first_name) {
        params.user_id = activeFilter.id;
      }
      // For regular contact list
      getCrmList(currentBrand?.brand_id, params);
    }
  }, [
    isFilter,
    currentBrand?.brand_id,
    countCheck,
    viewListsShow,
    activeFilter,
    continueLoader,
    ignoreCall,
    filters,
  ]);

  const getAudienceSetMembers = async (
    brandId,
    audienceSet,
    pageNum = 1,
    limit = 10,
    search = '',
  ) => {
    if (!brandId || !audienceSet) return;
    if (!brandId || !audienceSet) return;

    try {
      setIsLoading(true);

      // Only encode the filters if they exist
      const filtersParam = audienceSet?.filters
        ? `filters=${Base64.encode(JSON.stringify(audienceSet.filters))}`
        : '';

      // Call the API with all parameters including search
      const response = await AudienceSetMembersList(
        brandId,
        filtersParam,
        audienceSet.added_contact_person_ids || [],
        audienceSet.removed_contact_person_ids || [],
        pageNum, // Use the passed page number
        limit,
        search, // Pass the search parameter to the API
      );

      if (response?.data?.data?.members) {
        const { members, pagination } = response.data.data;

        // If it's the first page, replace the data, otherwise append
        const newData = pageNum === 1 ? members : [...crmLists, ...members];

        setCrmLists(newData);
        count = pagination?.total_count || 0;
        count1 = count;

        // Update the page number for the next load
        setPage(pageNum);
      }
    } catch (error) {
      console.error('Error fetching audience set members:', error);
      setCrmLists([]);
      setNo(false);
    } finally {
      setIsLoading(false);
    }
  };

  const getCrmList = (brandId, payload) => {
    // Handle audience_set type separately
    if (activeFilter?.type === 'audience_set') {
      getAudienceSetMembers(
        brandId,
        activeFilter,
        payload?.page,
        payload?.limit,
      );
      return;
    }

    // Original CRM list logic
    if (brandId) {
      const queryParams = {
        page: payload?.page,
        limit: payload?.limit,
        search: payload?.search,
        user_id: payload?.user_id,
        contact_origin: payload?.contact_origin,
        tag_id: payload?.tag_id,
        filters: Object.keys(filters)?.length > 0 ? filters : undefined,
      };

      crmListShow(brandId, queryParams)
        .then((res) => {
          if (res && res?.data?.data?.length > 0) {
            setNo(true);
            const newData =
              payload?.page === 1
                ? res?.data?.data
                : [...crmLists, ...res?.data?.data];
            setCrmLists(newData);
            count = res?.data?.contact_initial_count;
            count1 = res?.data?.contact_total_count;
          }
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      setCrmLists([]);
    }
  };

  const loadNextPage = () => {
    if (isLoading || crmLists.length >= count) return;

    const nextPage = page + 1;
    setIsLoading(true);
    setPage(nextPage); // Update the page state

    if (activeFilter?.type === 'audience_set') {
      getAudienceSetMembers(
        currentBrand?.brand_id,
        activeFilter,
        nextPage,
        10,
        isFilter, // Pass the search term for pagination
      );
    } else {
      getCrmList(currentBrand?.brand_id, {
        page: nextPage,
        limit: 10,
        search: isFilter,
        filters: filters,
        contact_origin: activeFilter?.name,
        tag_id: activeFilter?.tag ? activeFilter.id : undefined,
        user_id: activeFilter?.user_name ? activeFilter.id : undefined,
      });
    }
  };

  const loadNextPageView = () => {
    page += 1;
    setIsLoading(true);
    if (viewLists.length < count) {
      getViewList(currentBrand?.brand_id, {
        page: page,
        limit: 15,
        search: isFilter,
      });
    }
  };

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
  };

  const templateSearch = (value) => {
    setIsFilter(value);
  };

  const contactOrigins = () => {
    contactOriginApi().then((res) => {
      if (res && res?.data?.contact_origin_types?.length > 0) {
        setOrigins(res?.data?.contact_origin_types);
      }
    });
  };

  useEffect(() => {
    if (newContactActive) {
      contactOrigins();
    }
  }, [importFrom, newContactActive]);

  const [visibleColumns, setVisibleColumns] = useState(
    crmColumn
      ?.filter((column) => column?.selected)
      ?.map((column) => column?.label),
  );

  const handleSelect = (id) => {
    if (selectAll) {
      setDeselectedIds((prev) => {
        if (prev.includes(id)) {
          const newDeselected = prev.filter((itemId) => itemId !== id);
          setTotalSelectedCount(count - newDeselected.length);
          return newDeselected;
        } else {
          const newDeselected = [...prev, id];
          setTotalSelectedCount(count - newDeselected.length);
          return newDeselected;
        }
      });
    } else {
      setSelectedIds((prev) => {
        if (prev.includes(id)) {
          const newSelected = prev.filter((itemId) => itemId !== id);
          setTotalSelectedCount(newSelected.length);
          return newSelected;
        } else {
          const newSelected = [...prev, id];
          setTotalSelectedCount(newSelected.length);
          return newSelected;
        }
      });
    }

    setSelectedItems((prev) =>
      prev.map((item) =>
        item.id === id
          ? { ...item, selected: selectAll ? !item.selected : !item.selected }
          : item,
      ),
    );
  };

  const resetSelections = () => {
    setSelectAll(false);
    setSelectedIds([]);
    setDeselectedIds([]);
    setSelectedItems(
      crmLists.map((item) => ({
        id: item.id,
        selected: false,
      })),
    );
    setTotalSelectedCount(0);
  };

  const handleSelectAll = () => {
    const newSelectAll = !selectAll;
    setSelectAll(newSelectAll);

    if (newSelectAll) {
      setSelectedIds([]);
      setDeselectedIds([]);
      setTotalSelectedCount(count);
    } else {
      setSelectedIds([]);
      setDeselectedIds([]);
      setTotalSelectedCount(0);
    }

    setSelectedItems((prev) =>
      prev.map((item) => ({
        ...item,
        selected: newSelectAll,
      })),
    );
  };

  useEffect(() => {
    if (crmLists) {
      const selectedContactData = crmLists.map((item) => {
        if (selectAll) {
          return {
            id: item.id,
            selected: !deselectedIds.includes(item.id),
          };
        } else {
          return {
            id: item.id,
            selected: selectedIds.includes(item.id),
          };
        }
      });

      setSelectedItems(selectedContactData);
    }
  }, [crmLists, selectAll, deselectedIds, selectedIds]);

  useEffect(() => {
    resetSelections();
  }, [activeFilter]);

  const fetchAudienceSets = async () => {
    try {
      const response = await AudienceSetList(currentBrand?.brand_id);
      if (response?.data?.data) {
        setAudienceSets(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching audience sets:', error);
    }
  };

  // Function to handle audience set updates
  const handleAudienceUpdate = async (resetFilter = false) => {
    if (resetFilter) {
      setActiveFilter(0);
      await fetchAudienceSets();
      getCrmList(currentBrand?.brand_id, {
        page: 1,
        limit: 10,
        search: isFilter,
        filters: {},
      });
      return;
    }

    if (activeFilter?.type === 'audience_set') {
      // First, refresh the audience set data to get the latest state
      await fetchAudienceSets();
      try {
        const response = await AudienceSetSingle(
          currentBrand?.brand_id,
          activeFilter.id,
        );
        if (response?.data?.data) {
          const updatedAudience = response.data.data;
          const audienceSet = updatedAudience?.audience_set;
          // Update the active filter with the latest data
          setActiveFilter((prev) => ({
            ...prev,
            filters: audienceSet?.details?.selection_criteria || [],
            added_contact_person_ids:
              audienceSet?.details?.manually_added_contact_person_ids || [],
            removed_contact_person_ids:
              audienceSet?.details?.manually_removed_contact_person_ids || [],
          }));
          // Then refresh the member list
          getAudienceSetMembers(
            currentBrand?.brand_id,
            {
              ...activeFilter,
              filters: audienceSet?.details?.selection_criteria || [],
              added_contact_person_ids:
                audienceSet?.details?.manually_added_contact_person_ids || [],
              removed_contact_person_ids:
                audienceSet?.details?.manually_removed_contact_person_ids || [],
            },
            1, // Reset to first page
            10,
            isFilter || '',
          );
        }
      } catch (error) {
        console.error('Error refreshing audience set:', error);
        // Fallback to just refreshing the member list if the single fetch fails
        getAudienceSetMembers(
          currentBrand?.brand_id,
          activeFilter,
          1,
          10,
          isFilter || '',
        );
      }
    } else {
      await fetchAudienceSets();
      getCrmList(currentBrand?.brand_id, {
        page: 1,
        limit: 10,
        search: isFilter,
        filters: filters,
      });
    }
  };

  // Fetch audience sets when component mounts and when brand changes
  useEffect(() => {
    if (currentBrand?.brand_id) {
      fetchAudienceSets();
    }
  }, [currentBrand?.brand_id]);

  // Handle tag removal in main contact list through maincontactlist > crmtable
  const handleRemoveTag = async (contactId, tagId) => {
    try {
      const res = await crmTagRemove(contactId, tagId, currentBrand?.brand_id);
      if (res?.status === 200) {
        // Update the local state to remove the tag from the contact
        setCrmLists((prevLists) =>
          prevLists.map((contact) =>
            contact.id === contactId
              ? {
                  ...contact,
                  tags: contact.tags?.filter((tag) => tag.id !== tagId) || [],
                }
              : contact,
          ),
        );
        showSuccessToast(notification, 'Tag removed successfully');
      } else {
        showErrorToast(notification, 'Failed to remove tag');
      }
    } catch (error) {
      showErrorToast(notification, 'Failed to remove tag');
    }
  };

  // Handle tag assignment in main contact list through maincontactlist > crmtable
  const tagList = useSelector((state) => state.crm.tagList);
  const handleAddTag = async (contactId, tagId) => {
    try {
      const res = await crmTagSingleAssign(
        contactId,
        tagId,
        currentBrand?.brand_id,
      );
      if (res?.status === 200) {
        // Get the full tag object from Redux tagList
        const fullTag = tagList.find((tag) => tag.id === tagId);
        if (!fullTag) {
          showErrorToast(notification, 'Tag not found in tag list');
          return;
        }
        setCrmLists((prevLists) =>
          prevLists.map((contact) =>
            contact.id === contactId
              ? {
                  ...contact,
                  tags: contact.tags ? [...contact.tags, fullTag] : [fullTag],
                }
              : contact,
          ),
        );
        showSuccessToast(notification, 'Tag added successfully');
      } else {
        let error = res?.response?.data?.error;
        showErrorToast(notification, error || 'Failed to add tag');
      }
    } catch (error) {
      showErrorToast(notification, 'Failed to add tag');
    }
  };

  return (
    <div className="h-full bg-[var(--white)] w-100 flex-row">
      <div className="w-15">
        <Sidebar
          activeFilter={activeFilter}
          setActiveFilter={setActiveFilter}
          audienceSets={audienceSets}
          fetchAudienceSets={fetchAudienceSets}
        />
      </div>
      <div className="w-85">
        {viewListsCount > 0 && (
          <div className="w-100 bg-[#FF543E29] font15px-500 ptb-10 flex-row align-center justify-center gap-2">
            <span className="text-[var(--borderRed)] font14px-500">
              {viewListsCount}
            </span>
            <span className="text-[var(--borderRed)]">
              Contacts needs immediate attention
            </span>
            <span
              className="border border-[var(--font-600)] rounded-[5px] pointer"
              onClick={handleIgnore}
            >
              <span className=" text-[var(--font-600)] p-5 font14px-500">
                Ignore
              </span>
            </span>

            {!viewListsShow ? (
              <span
                className="bg-white rounded-[4px] px-2.5 py-0.5 pointer"
                onClick={handleView}
              >
                <span className="text-[var(--font-600)] font14px-500">
                  View
                </span>
              </span>
            ) : (
              <span
                className="bg-white rounded-[4px] px-2.5 py-0.5 pointer"
                onClick={handleAllContacts}
              >
                <span className="text-[var(--font-600)] font14px-500">
                  All Contacts
                </span>
              </span>
            )}
          </div>
        )}
        <Search
          visibleColumns={visibleColumns}
          setVisibleColumns={setVisibleColumns}
          templateSearch={templateSearch}
          isFilter={isFilter}
          setIsFilter={setIsFilter}
          setNo={setNo}
          no={no}
          origins={origins}
          setNewContactActive={setNewContactActive}
          newContactActive={newContactActive}
          setImportFrom={setImportFrom}
          importFrom={importFrom}
          continueLoader={continueLoader}
          setContinueLoader={setContinueLoader}
          viewListsShow={viewListsShow}
          onAudienceCreated={() => {
            fetchAudienceSets();
          }}
          selectedItems={selectedItems}
          onAudienceUpdated={handleAudienceUpdate}
          selectAll={selectAll}
          crmCount={count}
          activeFilter={activeFilter}
        />
        {/* Main Filter Component and Download Crm Report(crm list) */}
        {!viewListsShow && (
          <MainFilter
            onFilterChange={handleFilterChange}
            crmCount={count}
            crmSearch={isFilter}
            activeFilter={activeFilter}
            selectedItems={selectedItems}
            selectAll={selectAll}
          />
        )}
        <Header
          count={count}
          count1={count1}
          crmLists={crmLists}
          viewLists={viewLists}
          viewListsShow={viewListsShow}
          viewCount={viewCount}
          selectedItems={selectedItems}
          selectAll={selectAll}
          totalSelectedCount={totalSelectedCount}
          search={isFilter}
          activeFilter={activeFilter}
          setActiveFilter={setActiveFilter}
          onAudienceUpdated={handleAudienceUpdate}
        />
        <MainContactList
          crmLists={crmLists}
          isLoading={isLoading}
          visibleColumns={visibleColumns}
          count={count}
          count1={count1}
          loadNextPage={loadNextPage}
          isFilter={isFilter}
          setNo={setNo}
          no={no}
          viewListsShow={viewListsShow}
          viewLists={viewLists}
          loadNextPageView={loadNextPageView}
          handleCountry={handleCountry}
          countryListss={countryListss}
          countryTrue={countryTrue}
          handleCountryChange={handleCountryChange}
          handleDelete={handleDelete}
          handleUpdate={handleUpdate}
          handleProvince={handleProvince}
          handleProvinceChange={handleProvinceChange}
          stateList={stateList}
          provinceTrue={provinceTrue}
          handleEmail={handleEmail}
          emailTrue={emailTrue}
          handleEmailChange={handleEmailChange}
          cityTrue={cityTrue}
          cityList={cityList}
          handleCity={handleCity}
          handleCityChange={handleCityChange}
          viewCount={viewCount}
          selectedItems={selectedItems}
          handleSelect={handleSelect}
          handleSelectAll={handleSelectAll}
          selectAll={selectAll}
          totalSelectedCount={totalSelectedCount}
          handleRemoveTag={handleRemoveTag}
          handleAddTag={handleAddTag}
        />
      </div>
    </div>
  );
};

export default index;
